export const STATUS_META = {
  unverified: { label: 'Unverified', color: '#f59e0b', hint: 'Citations show "unverified"' },
  current: { label: 'Current', color: '#10b981', hint: 'Can back a verified answer' },
  replaced: { label: 'Replaced', color: '#94a3b8', hint: 'Quoted only as an older version' },
};

export const ssStyles = `
  .ss-page { min-height: 100vh; background: #0b1120; color: #e2e8f0; padding: 32px 40px 80px;
    font-family: 'IBM Plex Sans', -apple-system, 'Segoe UI', sans-serif; }
  .ss-head { display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; flex-wrap: wrap; margin-bottom: 28px; }
  .ss-kicker { font-size: 11px; letter-spacing: .14em; text-transform: uppercase; color: #64748b; margin: 0 0 6px; }
  .ss-title { font-size: 28px; font-weight: 700; color: #f8fafc; margin: 0; letter-spacing: -.01em; }
  .ss-sub { font-size: 14px; color: #94a3b8; margin: 6px 0 0; max-width: 620px; line-height: 1.5; }
  .ss-ghost { background: transparent; border: 1px solid #334155; color: #cbd5e1; padding: 8px 14px;
    border-radius: 8px; font-size: 13px; cursor: pointer; display: inline-flex; gap: 6px; align-items: center;
    transition: border-color .15s, color .15s; }
  .ss-ghost:hover { border-color: #64748b; color: #f8fafc; }
  .ss-tabs { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; margin-bottom: 18px; }
  .ss-tab { text-align: left; background: #111827; border: 1px solid #1e293b; border-radius: 12px; padding: 14px 16px;
    cursor: pointer; color: inherit; transition: border-color .15s, transform .15s; }
  .ss-tab:hover { transform: translateY(-1px); border-color: #334155; }
  .ss-tab.on { border-color: var(--c); box-shadow: inset 3px 0 0 var(--c); }
  .ss-tab-n { font-size: 24px; font-weight: 700; color: #f8fafc; font-variant-numeric: tabular-nums; }
  .ss-tab-l { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: var(--c); }
  .ss-tools { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; margin-bottom: 14px; }
  .ss-search { flex: 1; min-width: 220px; background: #111827; border: 1px solid #1e293b; color: #e2e8f0;
    border-radius: 8px; padding: 9px 12px; font-size: 14px; outline: none; }
  .ss-search:focus { border-color: #3b82f6; }
  .ss-check { display: inline-flex; gap: 8px; align-items: center; font-size: 13px; color: #94a3b8; cursor: pointer; }
  .ss-check input { width: 16px; height: 16px; accent-color: #3b82f6; }
  .ss-bulk { position: sticky; top: 12px; z-index: 5; background: rgba(17,24,39,.92); backdrop-filter: blur(14px);
    border: 1px solid #3b82f6; border-radius: 12px; padding: 14px 16px; margin-bottom: 14px; }
  .ss-bulk-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; font-size: 13px; }
  .ss-list { display: flex; flex-direction: column; gap: 8px; }
  .ss-card { background: #111827; border: 1px solid #1e293b; border-radius: 12px; padding: 14px 16px;
    animation: ss-in .25s ease both; transition: border-color .15s; }
  .ss-card:hover { border-color: #334155; }
  .ss-card.sel { border-color: #3b82f655; background: #121c31; }
  @keyframes ss-in { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
  .ss-row { display: flex; gap: 12px; align-items: flex-start; }
  .ss-main { flex: 1; min-width: 0; }
  .ss-name { font-size: 14px; font-weight: 600; color: #f1f5f9; word-break: break-word; }
  .ss-meta { font-size: 12px; color: #64748b; margin-top: 4px; display: flex; gap: 10px; flex-wrap: wrap; }
  .ss-link { color: #93c5fd; }
  .ss-pill { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap;
    color: var(--c); background: color-mix(in srgb, var(--c) 14%, transparent); border: 1px solid color-mix(in srgb, var(--c) 35%, transparent); }
  .ss-edit { margin-top: 12px; padding-top: 12px; border-top: 1px dashed #1e293b; display: grid; gap: 12px; min-width: 0; }
  .ss-edit > * { min-width: 0; max-width: 100%; }
  .ss-seg { display: inline-flex; justify-self: start; box-sizing: border-box; background: #0b1120; border: 1px solid #1e293b; border-radius: 9px; padding: 3px; flex-wrap: wrap; }
  .ss-seg button { background: transparent; border: 0; color: #94a3b8; padding: 7px 14px; border-radius: 7px;
    font-size: 13px; cursor: pointer; transition: background-color .15s, color .15s; }
  .ss-seg button.on { background: color-mix(in srgb, var(--c) 18%, #0b1120); color: var(--c); font-weight: 600; }
  .ss-field { display: grid; gap: 5px; font-size: 12px; color: #94a3b8; }
  .ss-field select, .ss-field input { background: #0b1120; border: 1px solid #334155; color: #e2e8f0; border-radius: 8px;
    padding: 8px 10px; font-size: 13px; width: 100%; max-width: 460px; box-sizing: border-box; color-scheme: dark; }
  .ss-actions { display: flex; gap: 8px; flex-wrap: wrap; }
  .ss-primary { background: #3b82f6; color: #fff; border: 0; padding: 8px 16px; border-radius: 8px; font-size: 13px;
    font-weight: 600; cursor: pointer; transition: background-color .15s; }
  .ss-primary:hover { background: #2563eb; }
  .ss-primary:disabled { opacity: .5; cursor: default; }
  .ss-msg { font-size: 13px; padding: 10px 14px; border-radius: 10px; margin-bottom: 14px; }
  .ss-msg.ok { background: #10b98118; color: #6ee7b7; border: 1px solid #10b98140; }
  .ss-msg.err { background: #ef444418; color: #fca5a5; border: 1px solid #ef444440; }
  .ss-empty { text-align: center; color: #64748b; padding: 48px 0; font-size: 14px; }
  @media (max-width: 640px) {
    .ss-page { padding: 20px 14px 60px; }
    .ss-tabs { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .ss-title { font-size: 22px; }
    .ss-row { flex-wrap: wrap; }
    .ss-main { flex: 1 1 calc(100% - 32px); }
    .ss-pill { margin-left: 28px; align-self: center; }
    .ss-seg button { padding: 7px 11px; }
  }
`;
